import { useWaitUserPermissions } from '~domains/auth';
import SandglassIcon from '~domains/partner-application/shared/assets/icons/sandglass.svg?react';
import { StatusScreenContent } from '~domains/partner-application/shared/ui/status-screen-content';

import { Screen } from '~shared/ui/screen';

import { PartnerApplicationMenuHeader } from '../../partner-application-menu-header';

export const SignedScreen = () => {
  useWaitUserPermissions();

  return (
    <Screen header={<PartnerApplicationMenuHeader />}>
      <StatusScreenContent
        icon={<SandglassIcon />}
        title={<>Please wait a&nbsp;moment…</>}
        description={
          <>
            We&#39;re creating your personal account. This usually takes
            a&nbsp;few minutes.
          </>
        }
        action={{
          label: 'Refresh',
          onClick: () => {
            window.location.reload();
          },
        }}
      />
    </Screen>
  );
};
